import * as THREE from "three";
import * as React from "react";
import * as ReactDOM from "react-dom";
import SceneManager from "./scene_mgr";
import PoolUIView from "./ui/pool_ui_view";
import AssetManager from "./utils/asset_manager";

async function main() {
  const assetManager = AssetManager.getInstance();
  assetManager.loadAssets(); 
  await assetManager.whenLoadComplete();
  const sceneManager = new SceneManager();
  ReactDOM.render(<PoolUIView  sceneManager={sceneManager}/>, document.getElementById("react-root"));
  
  // Create an instance of SceneManager
 

  const appElement = document.getElementById("app");
  if (appElement) {
    console.log("add the 3D scene", appElement);
    appElement.appendChild(sceneManager.renderer.domElement);
  }

  // Render loop
  const animate = () => {

    
    requestAnimationFrame(animate); // This will create a loop that causes the renderer to draw the scene every time the screen is refreshed

    // Call any animation updates here

    sceneManager.render(); // Render the scene
  };

  animate();
}


main();
